export default "__VITE_ASSET__2c87e7a7__"